import React from 'react';

export default function (props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={112} height={56} {...props}>
      <path
        fill="#001F23"
        d="M18.81 19.8h.08a2.74 2.74 0 0 1 2.74 2.74h.06a6.6 6.6 0 0 1 5.55-2.82c5.3 0 8.09 4.26 8.09 8.43a7.87 7.87 0 0 1-7.89 8 6.13 6.13 0 0 1-5.5-2.65h-.05v8.12a3.09 3.09 0 0 1-3.08-3.09V19.8zM27 22.4a5.36 5.36 0 0 0-5.21 5.53A5.305 5.305 0 1 0 32.4 28a5.51 5.51 0 0 0-5.4-5.6zm11.28-7.49h2.93v20.85h-2.93zm19.53 20.85v-2.42h-.06a6 6 0 0 1-5.29 2.81A8 8 0 0 1 44.17 28a8.1 8.1 0 0 1 8.29-8.29 6.2 6.2 0 0 1 5.29 2.62h.06v-2.18h2.93v15.61h-2.93zM52.46 22.4a5.54 5.54 0 1 0 5.41 5.6 5.34 5.34 0 0 0-5.41-5.58v-.02z"
      />
      <path
        fill="#009DB1"
        d="M52.46 36.15a9.39 9.39 0 0 1-1.72-.15C46.8 47.616 35.03 54.672 22.929 52.676c-12.102-1.997-20.98-12.46-20.98-24.726 0-12.266 8.878-22.729 20.98-24.726C35.03 1.228 46.799 8.284 50.74 19.9a9.73 9.73 0 0 1 1.76-.17h.23C48.641 7.064 35.933-.733 22.789 1.36 9.645 3.454-.013 14.813.035 28.123c.05 13.31 9.79 24.598 22.949 26.595 13.159 1.998 25.81-5.892 29.806-18.588l-.33.02z"
      />
      <path
        fill="#001F23"
        d="M75.42 35.76v-8.48c0-1.22 0-4.88-3.89-4.88-2.45 0-4.12 1.72-4.12 4.85v8.51h-2.92V20.15h2.73v1.66h.06a5.54 5.54 0 0 1 4.56-2.08 6.34 6.34 0 0 1 5.52 2.78 7.67 7.67 0 0 1 1 4v9.24l-2.94.01zm28.29 0a2.93 2.93 0 0 1-2.93-2.93v-10h-2.12v-2.68h2.12v-5.24a2.93 2.93 0 0 1 2.93 2.93v2.31h2.56v2.67h-2.56v12.94zm-6.45-8.03a8 8 0 1 0-16 .2 7.09 7.09 0 0 0 0 .79 8.4 8.4 0 0 0 8.42 7.41 8.63 8.63 0 0 0 6.8-3.25l-2.28-1.36a6 6 0 0 1-4.52 2 5.51 5.51 0 0 1-5.53-4.28h13.02c.055-.495.085-.992.09-1.49v-.02zm-13-.74a5.06 5.06 0 0 1 10.08 0H84.26z"
      />
      <path
        fill="#009DB1"
        d="M110.56 34.22a1.58 1.58 0 1 1-1.56-1.54 1.55 1.55 0 0 1 1.57 1.54"
      />
    </svg>
  );
}
